import {
  ordersTabsLabelsMap,
  pricingTabsLabelsMap,
  reportsTabsLabelsMap,
  settingTabsLabelsMap,
  themeTabsLabelsMap
} from 'constants/navigation';

export const tabLabelsMap: Record<string, string> = {
  ...ordersTabsLabelsMap,
  ...reportsTabsLabelsMap,
  ...pricingTabsLabelsMap,
  ...settingTabsLabelsMap,
  ...themeTabsLabelsMap
};

export const pageConfigMap: Record<string, { title: string; defaultSection: string }> = {
  settings: { title: 'Settings', defaultSection: 'portal' },
  statistics: { title: 'Analytics', defaultSection: '' },
  bundles: { title: 'Bundles', defaultSection: '' }
};
